import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index.js'
const { getCookie } = require('@/util/util.js')

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue'),
        meta: {
            showNav: true,
            hideNavData: true,
            showLogout: false,
            showDashboard: false,
            isProtected: false
        }
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "Dashboard" */ '../views/Dashboard.vue'),
        meta: {
            showNav: true,
            isProtected: true,
            showLogout: true,
            showDashboard: true
        }
    },
    {
        path: '/bank-transfer',
        name: 'BankTransfer',
        component: () => import(/* webpackChunkName: "BankTransfer" */ '../views/bankTransfer.vue'),
        meta: {
            showNav: true,
            isProtected: true,
            showLogout: true,
            showDashboard: true
        }
    },
    {
        path: '/settings',
        name: 'Settings',
        component: () => import(/* webpackChunkName: "Settings" */ '../views/Settings.vue'),
        meta: {
            showNav: true,
            isProtected: true,
            showLogout: true,
            showDashboard: true
        }
    },
    {
        path: '/reports',
        name: 'Reports',
        component: () => import(/* webpackChunkName: "Reports" */ '../components/dashboard/Reports.vue'),
        meta: {
            showNav: true,
            isProtected: true,
            showLogout: true,
            showDashboard: true
        }
    },
    {
        path: '/bankAccountDetails',
        name: 'BankAccountDetails',
        component: () => import(/* webpackChunkName: "BankAccountDetails" */ '../components/bankAccountDetails/BankAccountDetails.vue'),
        meta: {
            showNav: true,
            isProtected: true,
            showLogout: true,
            showDashboard: true
        }
    },
    // {
    //     path: '/invest/loans',
    //     name: 'Loans',
    //     component: () => import(/* webpackChunkName: "Loans" */ '../views/Loans.vue'),
    //     meta: {
    //         showNav: true,
    //         isProtected: true,
    //         showLogout: true,
    //         showDashboard: true
    //     }
    // },
    // {
    //     path: '/loans/invested',
    //     name: 'LenderLoans',
    //     component: () => import(/* webpackChunkName: "LenderLoans" */ '../views/LenderLoans.vue'),
    //     meta: {
    //         showNav: true,
    //         isProtected: true,
    //         showLogout: true,
    //         showDashboard: true
    //     }
    // },
    // {
    //     path: '/funds',
    //     name: 'Funds',
    //     component: () => import(/* webpackChunkName: "Funds" */ '../views/AddFunds.vue'),
    //     meta: {
    //         showNav: true,
    //         isProtected: true,
    //         showLogout: true,
    //         showDashboard: true
    //     }
    // },
    {
        path: '/plans',
        name: 'Plans',
        component: () => import(/* webpackChunkName: "Plans" */ '../views/PlanSelection.vue'),
        meta: {
            showNav: true,
            isProtected: true,
            showLogout: true,
            showDashboard: true
        }
    },
    // {
    //     path: '/invest',
    //     name: 'Invest',
    //     component: () => import(/* webpackChunkName: "Invest" */ '../views/Invest.vue'),
    //     meta: {
    //         showNav: true,
    //         isProtected: true,
    //         showLogout: true,
    //         showDashboard: true
    //     }
    // },
    {
        path: '/transactions',
        name: 'Transactions',
        component: () => import(/* webpackChunkName: "Transactions" */ '../views/transactionsV2.vue'),
        meta: {
            showNav: true,
            isProtected: true,
            showLogout: true,
            showDashboard: true
        }
    },
    {
        path: '/pay',
        name: 'Pay',
        component: () => import(/* webpackChunkName: "Pay" */ '../views/Payment.vue'),
        meta: {
            showNav: true,
            isProtected: true,
            showLogout: true,
            showDashboard: true
        }
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import(/* webpackChunkName: "Register" */ '../views/SignUp.vue'),
        meta: {
            showNav: true,
            hideNavData: true,
            showHomeInNav: true,
            showLogout: false,
            showDashboard: false,
            isProtected: false
        }
    },
    {
        path: '/onboarding',
        name: 'Onboarding',
        component: () => import(/* webpackChunkName: "Onboarding" */ '../views/LenderOnboarding.vue'),
        meta: {
            showNav: true,
            showOnlyLogout: true,
            isProtected: true,
            showLogout: true,
            showDashboard: false
        }
    },
    {
        path: '/planScreen',
        name: 'planScreen',
        component: () => import(/* webpackChunkName: "payment" */ '../views/planScreen.vue'),
        meta: {
            showNav: true,
            hideNavData: true,
            isProtected: true,
            showLogout: true,
            showDashboard: true
        }
    },
    {
        path: '/payment',
        name: 'payment',
        component: () => import(/* webpackChunkName: "payment" */ '../views/Payment.vue'),
        meta: {
            showNav: true,
            hideNavData: true,
            isProtected: true,
            showLogout: true,
            showDashboard: true
        }
    },
    {
        path: '/select-plan',
        name: 'selectPlan',
        component: () => import(/* webpackChunkName: "selectPlan" */ '../views/selectPlan.vue'),
        meta: {
            showNav: true,
            hideNavData: true,
            isProtected: true,
            showLogout: true,
            showDashboard: true
        }
    },
    {
        path: '/signup-complete',
        name: 'onBoardingComplete',
        component: () => import(/* webpackChunkName: "onBoardingComplete" */ '../components/lenderOnboarding/onBoardingComplete.vue'),
        meta: {
            showNav: true,
            hideNavData: false,
            isProtected: true,
            showHomeInNav: true,
            showLogout: true,
            showDashboard: true
        }
    },
    {
        path: '/portfolio/withdrawal',
        name: 'WithdrawPortfolio',
        component: () => import(/* webpackChunkName: "register" */ '../views/WithdrawPortfolio.vue'),
        meta: {
            showNav: true,
            showLogout: true,
            showDashboard: true,
            isProtected: true
        }
    },
    // {
    //     path: '/v2/portfolio/withdrawal',
    //     name: 'WithdrawPortfolioV2',
    //     component: () => import(/* webpackChunkName: "register" */ '../views/withdrawPortfolioV2.vue'),
    //     meta: {
    //         showNav: true,
    //         showLogout: true,
    //         showDashboard: true,
    //         isProtected: true
    //     }
    // },
    {
        path: '*',
        redirect: '/login'
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const accessToken = getCookie('token')
    if (to.path === '/login' && accessToken) {
        next('/dashboard')
    } else if (to.path === '/register' && accessToken) {
        next('/dashboard')
    } else if (to.path === '/onboarding' && accessToken) {
        if (store.state.dashboard.isLenderContractSigned) {
            next('/dashboard')
        } else if (from.path === '/dashboard' && !store.state.dashboard.isLenderContractSigned) {
            next()
        } else if (from.path === '/' || from.path === '/pay' || from.path === '/onboarding') {
            next()
        } else if (from.path !== '/register' && from.path !== '/login') {
            next('/register')
        }
        next()
    } else if (to.meta.isProtected && !accessToken) {
        next('/login')
    } else if (!to.meta.isProtected) {
        store.commit('isNotLoading')
    }
    next()
})

export default router
